import { DEFAULT_REPORT_PAGE, REPORT_PAGE_LIMIT } from '../../common/constants';
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: any = {
  loading: false,
      classModules: [],
  loadingReporting: false,
  adminReportingData1a: {},
  adminReportingData2a: {},
  adminReportingData1b: {},
  downloadReportData1aUrl: null,
  downloadReportData2aUrl: null,
  downloadReportData1bUrl: null,
  adminReportingDetail: {},
  studentReportingDetail: {},
  examsReporting: {},
  downloadExamsReportingUrl: null,
  loadingExamsReporting: false,
  examsReportingDetail: {},
  // filter options
  adminReportingFilter: {
    province: null,
    district: null,
    school_ids: null,
    class_ids: null,
    module_ids: null,
    status: null,
    from_date: null,
    to_date: null,
  },
  // filter options
  adminReporting2aFilter: {
    province: null,
    district: null,
    school: null,
    classes: null,
    module: null,
    status: null,
    from_date: null,
    to_date: null,
    page_size: REPORT_PAGE_LIMIT,
    page: DEFAULT_REPORT_PAGE,
  },
  // filter selected
  adminReportingFilterSelected: {
    province: '',
    district: '',
    school_ids: '',
    class_ids: '',
    module_ids: '',
    status: '',
    from_date: '',
    to_date: '',
  },
  adminReporting2aFilterSelected: {
    province2: null,
    ward2: null,
    school: null,
    classes: null,
    module: null,
    sub_module: null,
    status: null,
    from_date: null,
    to_date: null,
    page_size: REPORT_PAGE_LIMIT,
    page: DEFAULT_REPORT_PAGE,
  },
};

const adminReportingSlice = createSlice({
  name: 'reporting',
  initialState,
  reducers: {
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setAdminReporting1aData(state, action) {
      state.adminReportingData1a = action.payload;
    },
    setAdminReporting2aData(state, action) {
      state.adminReportingData2a = action.payload;
    },
    setAdminReporting1bData(state, action) {
      state.adminReportingData1b = action.payload;
    },
    setAdminReportingFilter(state, action) {
      if (Object.keys(action.payload)) {
        state.adminReportingFilter = {
          ...state.adminReportingFilter,
          ...action.payload,
        };
      }
    },
    setAdminReporting2aFilter(state, action) {
      if (Object.keys(action.payload)) {
        state.adminReporting2aFilter = {
          ...state.adminReporting2aFilter,
          ...action.payload,
        };
      }
    },
    setAdminReportingFilterSelected(state, action) {
      state.adminReportingFilterSelected = action.payload;
    },
    setAdminReporting2aFilterSelected(state, action) {
      state.adminReporting2aFilterSelected = action.payload;
    },
    setDownloadReportData1aUrl(state, action) {
      state.downloadReportData1aUrl = action.payload;
    },
    setDownloadReportData2aUrl(state, action) {
      state.downloadReportData2aUrl = action.payload;
    },
    setDownloadReportData1bUrl(state, action) {
      state.downloadReportData1bUrl = action.payload;
    },
    setLoadingReporting(state, action) {
      state.loadingReporting = action.payload;
    },
    setAdminReportingDetail(state, action) {
      state.adminReportingDetail = action.payload;
    },
    setStudentReportingDetail(state, action) {
      state.studentReportingDetail = action.payload;
    },
    setExamsReporting(state, action) {
      state.examsReporting = action.payload;
    },
    setDownloadExamsReportingUrl(state, action) {
      state.downloadExamsReportingUrl = action.payload;
    },
    setLoadingExamsReporting(state, action) {
      state.loadingExamsReporting = action.payload;
    },
    setExamsReportingDetail(state, action) {
      state.examsReportingDetail = action.payload;
    },
    setListClassModule(state, action) {
        state.classModules = action.payload;
    },
    clearReportingClassModules(state) {
      state.classModules = [];
    },
  },
});

export const {
  setLoading,
  setAdminReporting1aData,
  setAdminReporting2aData,
  setAdminReportingFilter,
  setAdminReporting2aFilter,
  setAdminReportingFilterSelected,
  setAdminReporting2aFilterSelected,
  setAdminReporting1bData,
  setDownloadReportData1aUrl,
  setDownloadReportData2aUrl,
  setDownloadReportData1bUrl,
  setLoadingReporting,
  setAdminReportingDetail,
  setStudentReportingDetail,
  setExamsReporting,
  setDownloadExamsReportingUrl,
  setLoadingExamsReporting,
  setExamsReportingDetail,
  setListClassModule,
  clearReportingClassModules,
} = adminReportingSlice.actions;

export default adminReportingSlice.reducer;
